import { render } from "./StatsLoaderComponent.vue?vue&type=template&id=9ce255b4&scoped=true"
const script = {}

import "./StatsLoaderComponent.vue?vue&type=style&index=0&id=9ce255b4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ce255b4"]])

export default __exports__